var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cq-page"},[_c('template-history',{key:_vm.routeKey,attrs:{"api":_vm.api,"app-id":_vm.appId},on:{"execute":_vm.onExecute,"edit":_vm.onEdit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48085908","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--5!./src/component/data-grid/custom-query/pages/history-page.vue
// module id = 132
// module chunks = 0